import { pageData } from "../../../constants/pagedata"
import { capitalizeFirst } from "../../../utils/utils"
import { ContentPicker } from "../../../components/contentpicker"

interface StepTwoProps{userContentList:string[], contentClick:Function, contentSelected:string[], pageSelected:string};

export const StepTwo=function(props:StepTwoProps){
	let contentGroup=0;
	if(props.pageSelected!=='')contentGroup=pageData[props.pageSelected].contentGroup;
	let isComplete=contentGroup===0||props.contentSelected[0]!=='';

	let dispMsg="No content for this page";
	if(contentGroup!==0){
		if(props.contentSelected[0]!==''){
			if(props.contentSelected[1]==='user'){
				dispMsg="Content chosen: Your content - "+capitalizeFirst(props.contentSelected[0]);
			}else{
				dispMsg="Content chosen: "+capitalizeFirst(props.contentSelected[0]);
			}
		}else{
			dispMsg="Choose content to use";
		}
	}

	return(
		<div className='teachers-taskcreater-step'>
			<hr />
			<h3>Step 2{isComplete&&'  - Complete'}</h3>
			<p>{dispMsg}</p>
			<ContentPicker
				pageSelected={props.pageSelected}
				contentClick={props.contentClick}
				userContentList={props.userContentList}
				contentSelected={props.contentSelected}/>
		</div>
	)
};